import Animations from '../../../../content-theme/assets/js/modules/Animations';


class ChildThemeAnimations extends Animations {
  constructor() {
    super();  // Call the parent class constructor
  }

  // Override the 'events' method
  events() {
    window.addEventListener("scroll", () => this.reveal());
    this.fixRevealRight();  // Call the new method here
  }

  // Add a new method
  fixRevealRight() {
    const revealRightElements = document.querySelectorAll('.reveal.right');
    revealRightElements.forEach((element) => {
      element.parentElement.style.overflow = 'hidden';
    });
  }
}

export default ChildThemeAnimations;
